import styled from 'styled-components';

export const AnimationContainer = styled.div`
  position: relative;
`;

export const AnimationSlider = styled.div`
  position: absolute;
  left: -126px;
  top: 3px;
  width: 100px;
  padding: 13px 48px 7px 19px;
  background: #fff;
  border-radius: 21px;
`;
